import React from "react";

const HomePage = React.lazy(() => import("./Home/index"));
const LokasiPage = React.lazy(() => import("./Lokasi/index"));
const InfoLombaPage = React.lazy(() => import("./InfoLomba/index"));
const KlasemenPertandinganPage = React.lazy(() =>
  import("./KlasemenPertandingan/index")
);
const JadwalPertandinganPage = React.lazy(() =>
  import("./JadwalPertandingan/index")
);
const Registration = React.lazy(() => import("./v2/Registration/index"));
const FormRegistration = React.lazy(() => import("./v2/FormRegistration"));
const FormAddPlayer = React.lazy(() => import("./v2/FormAddPlayer"));
const ReaderDetailPage = React.lazy(() => import("./v2/ReaderDetail"));

export {
  HomePage,
  LokasiPage,
  InfoLombaPage,
  JadwalPertandinganPage,
  KlasemenPertandinganPage,
  Registration,
  FormRegistration,
  FormAddPlayer,
  ReaderDetailPage,
};
